const URL = process.env.REACT_APP_BASE_URL;

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const REACT_PUBLIC_AZURE_CLIENT_ID =
  process.env.REACT_APP_AZURE_CLIENT_ID;

export const REACT_PUBLIC_AZURE_TENANT_ID =
  process.env.REACT_APP_AZURE_TENANT_ID;

export const REACT_PUBLIC_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

export default URL;

export { SECRET_KEY };
